import React, { Component } from 'react';
import { Link } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';


import 'react-datepicker/dist/react-datepicker.css';

import OrganizationSelect from "../../components/OrganizationSelect";
import ApplicationStore from "../../stores/ApplicationStore";


class DownloadForm extends Component {
  constructor() {
    super();

    var lastMonth;
    var today = new Date();
    var todayStr = "" + today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();

    var prevYear = today.getFullYear();
    var prevMonth = today.getMonth();
    if (prevMonth == 0) {
      prevYear -= 1;
      prevMonth = 12;
    }
    var preDay = (new Date(prevYear, prevMonth, 0)).getDate();
    if (today.getDate() < preDay) {
      preDay = today.getDate();
    }

    lastMonth = "" + prevYear + "-" + prevMonth + "-" + preDay;

    this.state = {
      timeRange: {
        beginDate: lastMonth,
        endDate: todayStr,
        timezone: "8",
        exportSig: false,
      },
      application: {},
      enableParseData: false,
      beginTime: moment(lastMonth),
      endTime: moment(todayStr),
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    let tr = this.state.timeRange;

    tr.id = nextProps.application.id;
    this.setState({ timeRange: tr })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.application !== this.props.application) {
      this.setState({ application: this.props.application })
    }
  }

  handleSubmit (e) {
    let tr = this.state.timeRange;

    e.preventDefault();

    tr.beginDate = this.state.beginTime.format("YYYY-MM-DD");
    tr.endDate = this.state.endTime.format("YYYY-MM-DD");
    tr.enableParseData = this.state.enableParseData;
    console.log("handleSubmit. tr=", tr);

    this.props.onSubmit(tr);
  }

  onChange (field, date) {
    if (field === "beginTime") {
      this.setState({ beginTime: date })
    } else if (field === "endTime") {
      this.setState({ endTime: date })
    }
  }

  render () {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="form-group">
          <label className="control-label" htmlFor="date1">Start date</label>
          <DatePicker
            id="date1"
            dateFormat="YYYY-MM-DD"
            showYearDropdown
            selected={this.state.beginTime}
            onChange={this.onChange.bind(this, "beginTime")}
          />
        </div>

        <div className="form-group">
          <label className="control-label" htmlFor="date2">End date</label>
          <DatePicker
            id="date2"
            dateFormat="YYYY-MM-DD"
            showYearDropdown
            selected={this.state.endTime}
            onChange={this.onChange.bind(this, "endTime")}
          />
        </div>
        <hr />

        {/* {this.state.application.appType !=2 && */}
        <div className="form-group">
          <input
            type="checkbox"
            id="enableParseData"
            checked={this.state.enableParseData}
            onChange={(e) => this.setState({ enableParseData: e.target.checked })}
            style={{ marginRight: "8px" }}
          />
          <label className="control-label" htmlFor="enable">Enable Data Analysis</label>
        </div>
        {/* } */}
        <button type="submit" className="btn btn-primary pull-right">Download</button>
      </form>
    );
  }
}


class DownloadApplication extends Component {
  constructor() {
    super();

    this.state = {
      application: {},
      extPath: "",
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount () {
    ApplicationStore.getApplication(this.props.params.applicationID, (application) => {
      this.setState({
        application: application,
        match: this.props.params.match,
        extPath: (typeof application.appType !== 'undefined' && application.appType === 2) ? "/subMeter/list" : "",
      });
    });
  }


  onSubmit (timeRange) {
    if (this.props.params.match !== "all") {
      timeRange.match = this.props.params.match;
    }
    console.log("onSubmit timeRange===>", timeRange);
    ApplicationStore.downloadApplication(this.props.params.applicationID, timeRange, () => {
      //this.context.router.push('/organizations/'+this.state.application.organizationID+'/applications/'+this.props.params.applicationID+this.state.extPath);
    });
  }

  render () {

    return (
      <div>
        <ol className="breadcrumb">
          <li><Link to="/organizations">Organizations</Link></li>
          <li><OrganizationSelect organizationID={this.props.params.organizationID} /></li>
          <li><Link to={`/organizations/${this.props.params.organizationID}/applications`}>Applications</Link></li>
          <li><Link to={`/organizations/${this.props.params.organizationID}/applications/${this.state.application.id}${this.state.extPath}`}>{this.state.application.name}</Link></li>
          <li className="active">Users</li>
        </ol>

        <hr />
        <div className="panel panel-default">
          <div className="panel-body">
            <DownloadForm application={this.state.application} match={this.state.match} onSubmit={this.onSubmit} />
          </div>
        </div>
      </div>
    );
  }
}

export default DownloadApplication;



// WEBPACK FOOTER //
// ./src/views/applications/DownloadApplication.js